import * as React from 'react';
import type { CompanyOwner } from '../../state/editor';
import { OwnerCompanyForm } from '../OwnerCompanyForm';
import { BoxHeading } from '../box';
import { EditItem } from './EditItem';

interface Props {
  owner: CompanyOwner;
  onDone: () => void;
}

export const EditCompanyItem: React.FC<Props> = props => (
  <EditItem data-testid="RoleSection">
    <BoxHeading>Endre detaljer</BoxHeading>
    <OwnerCompanyForm
      initialOrgId={props.owner.item.orgId}
      onDone={props.onDone}
    />
  </EditItem>
);
